import InvoiceItem, { InvoiceFiltersFormData } from '~/types/InvoiceItem';
import { ActionKeys } from './constants';

export function exportTransactionsInvoiceItems(filter: InvoiceFiltersFormData) {
  return <const>{
    type: ActionKeys.TRANSACTIONS_INVOICE_ITEMS_EXPORT,
    payload: { filter },
  };
}

export function exportTransactionsInvoiceItemsReset() {
  return <const>{
    type: ActionKeys.TRANSACTIONS_INVOICE_ITEMS_EXPORT_RESET,
  };
}

export function exportTransactionsInvoiceItemsSuccess(exportURL: string) {
  return <const>{
    type: ActionKeys.TRANSACTIONS_INVOICE_ITEMS_EXPORT_SUCCESS,
    payload: { exportURL },
  };
}

export function exportTransactionsInvoiceItemsError(err: string) {
  return <const>{
    type: ActionKeys.TRANSACTIONS_INVOICE_ITEMS_EXPORT_ERROR,
    payload: { err },
  };
}

export function fetchTransactionsInvoiceItems(queryParams?: {
  pageNumber?: number;
  pageSize?: number;
  searchQuery?: string;
  startDate?: string;
  endDate?: string;
  paymentStatus?: boolean;
  invoiceItemType?: string;
  shopApp?: string;
  carrierAccountId?: string;
}) {
  return <const>{
    type: ActionKeys.TRANSACTIONS_INVOICE_ITEMS_FETCH,
    payload: {
      ...queryParams,
    },
  };
}

export function fetchTransactionsInvoiceItemsSuccess(
  invoiceItems: InvoiceItem[],
  page: number,
  pageCount: number,
) {
  return <const>{
    type: ActionKeys.TRANSACTIONS_INVOICE_ITEMS_FETCH_SUCCESS,
    payload: {
      invoiceItems,
      page,
      pageCount,
    },
  };
}

export function fetchTransactionsInvoiceItemsError(err: Error) {
  return <const>{
    type: ActionKeys.TRANSACTIONS_INVOICE_ITEMS_FETCH_ERROR,
    payload: { err },
  };
}

export function fetchInvoiceItemsOfInvoice(invoiceId: string) {
  return <const>{
    type: ActionKeys.DISPLAY_INVOICE_INVOICE_ITEMS_FETCH,
    payload: { invoiceId },
  };
}

export function fetchInvoiceItemsOfInvoiceSuccess(invoiceItems: InvoiceItem[]) {
  return <const>{
    type: ActionKeys.DISPLAY_INVOICE_INVOICE_ITEMS_FETCH_SUCCESS,
    payload: {
      invoiceItems,
    },
  };
}

export function fetchInvoiceItemsOfInvoiceError(err: string) {
  return <const>{
    type: ActionKeys.DISPLAY_INVOICE_INVOICE_ITEMS_FETCH_ERROR,
    payload: { err },
  };
}

export type InvoiceItemActions =
  | ReturnType<typeof exportTransactionsInvoiceItems>
  | ReturnType<typeof exportTransactionsInvoiceItemsReset>
  | ReturnType<typeof exportTransactionsInvoiceItemsSuccess>
  | ReturnType<typeof exportTransactionsInvoiceItemsError>
  | ReturnType<typeof fetchTransactionsInvoiceItems>
  | ReturnType<typeof fetchTransactionsInvoiceItemsSuccess>
  | ReturnType<typeof fetchTransactionsInvoiceItemsError>
  | ReturnType<typeof fetchInvoiceItemsOfInvoice>
  | ReturnType<typeof fetchInvoiceItemsOfInvoiceSuccess>
  | ReturnType<typeof fetchInvoiceItemsOfInvoiceError>;
